var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container dashboard-container"},[_vm._v(" hello,dashboard ")])
}
var staticRenderFns = []

export { render, staticRenderFns }